<template>
  <DBox
    :id="'cmp-td-contact-relations'"
    :addButton="false"
    :addLink="true"
    :addLinkLabel="`${$t('add_new_travel_party')}`"
    @add_click="addContactRelation"
    :rightMenu="[
      {
        text: $t('get_contacts_via_artists'),
        value: 'get_contacts_button',
      }
    ]"
    @menuClick="onMenuClick"
  >
  <!-- <div class="contact-relations dbox"> -->
    <!-- <div class="dt-list v2" v-if="booking.contact_relations">
      <div v-for="contact of booking.contact_relations" :key="contact.contact_id" class="dt-list-item">
        <div class="dt-list-item--body">
          <div class="dt-list-item--text">{{contact.contact_name}}</div>
          <div class="dt-list-item--icon">
            <div class="dt-icon-container" @click="e => removeContactRelation(contact)">
              <img src="static/icons/delete.svg" class="dt-icon v5 s1" alt />
            </div>
          </div>
        </div>
      </div>
    </div> -->
    <div class="ut-flex" style="flex-wrap: wrap;">
      <Badge
        v-for="contact of  booking.contact_relations"
        :key="contact.contact_id"
        :item="contact"
        :stringKey="'contact_name'"
        @delete="removeContactRelation"
      />
    </div> 
  <!-- <div class="dbox-title-bar--options">
      <img 
        @click="addContactRelation"
        src="static/icons/add-icon.svg" 
        class="dt-icon v4" 
        alt="">

    </div> -->
  </DBox>
</template>

<script>
import AddPerson from "./add-person";
import Badge from "@/dt-plugins/badge/badge"

export default {
  components: {
    AddPerson,
    Badge
  },
  props: ['booking'],
  data: function() {
    return {
      addContactRelationDialog: false,
      addPersonDialog: false
    };
  },
  computed: {

  },
  methods: {
    removeContactRelation: function(contactRelation) {
      this.$emit('deleted', contactRelation);
    },
    addContactRelation: function() {
      this.$router.push({
        ...this.$route,
        query: {
          modal: "add_contact_relation",
          external_id: this.booking.cdate.calendar_date_id,
          external_table: "calendar_dates"
        }
      });
    },
    
    onMenuClick(payload) {
      console.log({"payload": payload});
      if (payload == 'get_contacts_button') {
        this.$emit('get_contacts_button', true);
      }
    }
  }
};
</script>

<style lang="scss">
.cmp-td-contact-relations{

}
</style>